<template>
  <div class="add2homescreen__wrapper" :class="{ 'add2homescreen__wrapper--iphone': iphone }" v-if="show && user">
    <div class="add2homescreen">
      <div class="add2homescreen__close" @click="close">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 31.113 31.113" style="enable-background:new 0 0 31.113 31.113;" xml:space="preserve" width="16px" height="16px">
          <line style="fill:none;stroke:#766E6A;stroke-width:3;stroke-miterlimit:10;" x1="30.406" y1="0.707" x2="0.707" y2="30.406"/>
          <line style="fill:none;stroke:#766E6A;stroke-width:3;stroke-miterlimit:10;" x1="30.406" y1="30.406" x2="0.707" y2="0.707"/>
        </svg>
      </div>
      <div class="add2homescreen__icon"><img src="/static/images/icons-512-android.png"/></div>
      <div class="add2homescreen__text" @click="install">
        <div v-if="user.type === 1">Installez l'application COOLOC pour un accès rapide et pour être notifié
        des informations importantes sur votre location.</div>
        <div v-else>Installez l'application COOLOC pour un accès rapide et pour être notifié
          des informations importantes sur vos biens en location.</div>
        <button v-if="android" class="add2homescreen__button" @click="installAndroid">Installer</button>
        <div v-else-if="ios" class="add2homescreen__action">
          Appuyez sur
          <svg enable-background="new 0 0 50 65" height="30px" version="1.1" viewBox="0 0 50 65" width="30px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <polyline fill="none" points="17,10 25,2 33,10" stroke="#1A79FB" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
            <line fill="none" stroke="#1A79FB" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2" x1="25" x2="25" y1="32" y2="2.333"/>
            <path d="M17,17H8v32h34V17h-9" fill="none" stroke="#1A79FB" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2"/>
          </svg>
          puis ‘Sur l'écran d'accueil’
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus, showInstallPrompt } from '@/main'

export default {
  data: () => ({
    user: null,
    ios: ['iPhone', 'iPad', 'iPod'].includes(navigator.platform),
    iphone: navigator.platform === 'iPhone',
    android: /(android)/i.test(navigator.userAgent),
    show: false,
  }),
  mounted() {
    // Check if prompt is needed
    if (!window.localStorage || navigator.standalone) return

    // iOs or Android
    if (!this.ios && !this.android) return

    const lastAsked = localStorage.getItem('a2hs:asked')
    if (lastAsked) {
      const daysSinceAsked = (Date.now() - parseInt(lastAsked)) / (1000 * 60 * 60 * 24)
      if (daysSinceAsked < 30) return
    }

    eventBus.$on('userChanged', user => {
      this.user = user
    })
    eventBus.$once('pwaInstallAvailable', ok => {
      // PWA event for Android
      if (ok) {
        this.show = !localStorage.getItem('a2hs:asked')
      }
    })

    if (this.ios) {
      // Show after 5 seconds on iOS, there is no specific event
      setTimeout(() => {
        if (/^Dashboard/.test(this.$route.name)) {
          this.show = true
        }
      }, 5 * 1000)
    }
  },
  methods: {
    close() {
      localStorage.setItem('a2hs:asked', Date.now().toString())
      this.show = false
    },
    install() {
      if (this.android) {
        this.installAndroid()
      }
    },
    installAndroid() {
      showInstallPrompt()
        .then(res => {
          localStorage.setItem('a2hs:asked', Date.now().toString())
          this.close()
          if (window.gtag) gtag('event', 'pwa-install', { success: res === true })
        })
    },
  },
}
</script>

<style lang="scss">

.add2homescreen__wrapper {
	position: fixed;
	z-index: 9999999999;
	top: 60px;
	left: 0;
	width: 100vw;
  background-color: rgba(#000, 0.3);
	overflow: hidden;
	transition: opacity .3s ease;
	cursor: pointer;

  &--iphone {
    top: initial;
    bottom: 0;

    .add2homescreen {
      margin-bottom: 16px;
      border: #f0f0f0;
      background: #f0f0f0;
    }
    .add2homescreen:after {
      content: "";
      position: absolute;
      top: 100%;
      left: calc(50% - 16px);
      border-top: 16px solid #f0f0f0;
      border-top-color: inherit;
      border-left: 16px solid transparent;
      border-right: 16px solid transparent;
    }
  }
}

.add2homescreen {
	position: relative;
	width: 100%;
  margin-bottom: 5px;
  background-color: #f0f0f0;
	box-shadow: 0 2px 8px rgba(#000, .33);
	cursor: auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  &__close {
    flex: 40px 0;
    margin-left: 12px;
    margin-right: 8px;
    cursor: pointer;
  }

  &__icon {
    flex: 40px 0;
    > img {
      max-width: 40px;
      width: 40px;
      height: 40px;
    }
  }

	&__text {
		padding: 12px;
		color: #766E6A;
		font-size: 12px;
		line-height: 16px;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 8px;
	}

	&__button {
    display: inline-block;
    border: solid 1px $primary;
    font-size: 14px;
    color: $primary;
    padding: 6px 12px;
    margin-right: 6px;
    text-align: center;
    text-decoration: none;
    background: #FFF;
    cursor: pointer;

    &:hover {
      background: $primary;
      color: white;
    }
	}

  &__action {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
</style>
